import mirrorCreator from "mirror-creator";

export default mirrorCreator([
    "GET_INITIAL_PROFILE",
    "GET_USER",
    "GET_ORG",
    "GET_WORK_REST_INFO",
    "GET_NOTIFICATION_OPTIONS",
    "GET_TIMEZONE",
    "GET_REGION_SETTINGS",
    "GET_DEFAULT_ROUTE_OPTIONS",
    "GET_REPORT_EXECUTION_TIMES",
    "GET_CONTROL_POINTS_SETTINGS",
    "GET_SYNC_SYSTEMS",
    "GET_PROFITABILITY_OF_BID_SETTINGS",
    "GET_DRIVER_EDUCATION_RESOURCE_SETTINGS",
    "GET_BID_CARS_PLANNING_SETTINGS",
    "GET_CHATS_SETTINGS",
    "GET_REFUELING_SETTINGS",
    "GET_EXPLOITATION_SETTINGS",
]);
